import React from "react";

export const Team = () => {
  const originalMembers = [
    {
      name: "Professor Rahula Attalage",
      image: "/assets/team/rahula.webp",
    },
    {
      name: "Dr. Malitha Wijesundara",
      image: "/assets/team/malitha.webp",
    },
  ];

  const additionalMembers = [
    {
      name: "Prof. Charitha Jayaruk",
      image: "/assets/team/Prof.-Jayaruk.webp",
    },
    {
      name: "Dr. Virajith Gamage",
      image: "/assets/team/Dr.-Virajith.webp",
    },
    {
      name: "Dr. Samurdhi Jayamaha",
      image: "/assets/team/Dr.-Samurdhi-Jayamaha.webp",
    },
    { name: "Mr. Lakmal Eranda", image: "/assets/team/Mr.-Lakmal.webp" },
    {
      name: "Mr. Pramadhi Atapattu",
      image: "/assets/team/Mr.-Pramadhi.webp",
    },
    {
      name: "Ms. Muditha Muthucumarana",
      image: "/assets/team/Ms.-Muditha.webp",
    },
    {
      name: "Dr. Praneeth Ratnayake",
      image: "/assets/team/Dr.-Praneeth-Ratnayake.webp",
    },
    {
      name: "Ms. Sithara Gunasena",
      image: "/assets/team/Ms.-Sithara-Gunasena.webp",
    },
    {
      name: "Ms. Hiranga Wijedasa",
      image: "/assets/team/Ms.-Hiranga-Wijedasa.webp",
    },
    {
      name: "Mr. Shanitha Mirihana",
      image: "/assets/team/Mr.-Shanitha.webp",
    },
    {
      name: "Mr. Thimira Abeywardhana",
      image: "/assets/team/Mr.-Thimira.webp",
    },
    {
      name: "Ms. Malika Lakmali",
      image: "/assets/team/Ms.-Malika-Lakmali.webp",
    },
    {
      name: "Mr. Kaushalya DeSilva",
      image: "/assets/team/Mr.-Kaushalya-DeSilva.webp",
    },
    {
      name: "Ms. Chathuri Samarasinghe",
      image: "/assets/team/Ms.-Chathuri-Samarasinghe.webp",
    },
    {
      name: "Ms. Navodya Rajapakse",
      image: "/assets/team/Ms.navodya-Rajapakse.webp",
    },
  ];

  return (
    <div
      className="flex flex-col h-full min-h-screen bg-slate-900 category-bg-color"
      id="team"
    >
      <div className="max-w-[1280px] mx-auto py-6 lg:py-16">
        <div className="text-center lg:mx-8 flex justify-center flex-col my-6 items-center">
          <h1
            className="text-4xl font-bold sm:text-6xl capitalize tracking-wider text-[#dd7538] my-2 lg:my-0 px-8 lg:px-0 section-title relative w-fit text-center"
            style={{ fontFamily: "Bebas Neue" }}
            data-aos="fade-left"
            data-aos-delay="100"
          >
            Our Team
          </h1>
          <p
            className="mt-4 lg:mt-8 text-white text-md lg:text-lg w-full lg:w-3/4 px-8"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            NEA is driven by a dynamic team led by Professor Rahula Attalage and
            Dr. Malitha Wijesundara. Their leadership, academic expertise, and
            unwavering commitment to the project ensure its success and
            establish it as the benchmark for recognizing and honoring
            outstanding educators in Sri Lanka.
          </p>
        </div>

        {/* Original Team Members - Centered */}
        <div className="py-3 sm:py-8 flex flex-col sm:flex-row justify-center items-center gap-10">
          {originalMembers.map((member, index) => (
            <div
              className="flex flex-col justify-center items-center"
              key={index}
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-[200px] h-[250px] sm:w-[300px] sm:h-[400px] object-cover object-top rounded-lg my-4"
                data-aos="fade-up"
                data-aos-delay="100"
                loading="lazy"
              />
              <h1 className="text-lg font-bold sm:text-xl capitalize tracking-wider text-[#dd7538] lg:my-0 px-8 lg:px-0 relative w-fit text-center">
                {member.name}
              </h1>
            </div>
          ))}
        </div>

        <div className="py-3 sm:py-8">
          <div>
            <div className="max-w-6xl mx-auto grid gap-8 grid-cols-1 md:grid-cols-3 lg:grid-cols-5 justify-items-center">
              {additionalMembers.map((member, index) => (
                <div
                  className="flex flex-col justify-start items-center w-full"
                  key={index}
                >
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-[150px] h-[200px] sm:w-[200px] sm:h-[300px] object-cover object-top rounded-2xl my-4 shadow-lg"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  />
                  <div className="w-full min-h-[60px] sm:min-h-[80px] flex justify-center items-start px-2 sm:px-4">
                    <h1 className="text-base sm:text-lg lg:text-xl font-bold capitalize tracking-wider text-[#dd7538] m-0 text-center line-clamp-2">
                      {member.name}
                    </h1>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
